import config from 'config';
import tmpl from './login.phtml';
import View from 'lib/View';

export default View.extend({
	template: tmpl,

	events: {
		'submit form': 'onSubmit',
		'keyup textarea': 'removeInvalidFeedback',
		'change :input': 'removeInvalidFeedback',
		'render': 'scrollToInvalidFeedback',
	},

	initialize: function()
	{
		// Mettre à jour le formulaire quand le réseau change
		this.listenTo( app, 'online', this.render );
	},


	onSubmit: function( evt )
	{
		evt.preventDefault();

		// Connexion impossible hors réseau
		if( !app.is('online') )
		{
			return;
		}

		var data = this.$('form').serializeJSON();


		// Chargement en cours
		this.$(":input, button").prop('disabled',true);
		this.$(".alert").remove();

		// Envoi de la requête
		var connecting = $.post( config.url.login, data ).then( function( response )
		{
			return app.signin( response, 'Connexion à l\'application' );
		});

		connecting.done(function()
		{
			app.redirect( 'default/index' );
			app.commit();
		});

		connecting.fail( _.bind( function( xhr )
		{
			this.$(':input, button').prop('disabled', false );
			this.model.set( data );
			this.model.setErrors( xhr.responseJSON );
			this.render();
		}, this ));

		app.addMessage( 'Connexion à l\'application', connecting );
	},


	render: function()
	{
		this.doRender({
			user: this.model,
		});
	}

});
